import { Button } from 'antd';
import React, { useState } from 'react';
import { addAdminRights, removeAdminRights } from '../../lib/api/user-api';
import ChangeRole from './ChangeRole';

interface Props {
  username: string;
  role: string;
  onChangeRole: () => void;
}

const ChangeRoleButton = ({ username, role, onChangeRole }: Props) => {
  const [addChangeRoleVisible, setChangeRoleVisible] = useState<boolean>(false);
  const onSubmitChangeRole = async (username: string, role: string) => {
    if (role === 'ADMIN') {
      await addAdminRights(username);
    } else {
      await removeAdminRights(username);
    }
    setChangeRoleVisible(false);
    onChangeRole();
  };

  const clickChangeRoleHandler = () => {
    setChangeRoleVisible(true);
  };

  const onCloseChangeRole = () => {
    setChangeRoleVisible(false);
  };

  return (
    <>
      <Button type="link" className="m-0 p-0" onClick={() => clickChangeRoleHandler()}>
        Change role
      </Button>
      <ChangeRole
        visible={addChangeRoleVisible}
        onSubmit={onSubmitChangeRole}
        onCancel={onCloseChangeRole}
        username={username}
        roleIn={role}
      />
    </>
  );
};

export default ChangeRoleButton;
